<template>
    <div class="sign-in">
        <div class="error-card" v-if="error">
            <img src="@/assets/icons/ic_error.png" class="icon">
            <p>{{ error }}</p>
        </div>

        <div class="success-card" v-if="isPasswordResetSuccess">
            <img src="@/assets/icons/ic_error.png" class="icon">
            <p>You can now use your new password.</p>
        </div>

        <form @submit.prevent="login()">
            <label>
                Email Address

                <input
                    type="email"
                    placeholder="Email@info.com"
                    v-model="signIn.email"
                >
            </label>

            <label>
                Password

                <input
                    type="password"
                    placeholder="Enter Password"
                    autocomplete
                    v-model="signIn.password"
                >
            </label>

            <a @click="$router.push('/forgot-password')">
                Can't remember password
            </a>

            <button :disabled="loading">
                {{ loading ? 'Loading...' : 'Login' }}
            </button>
        </form>
    </div>
</template>

<script>
import Form from '@/class/Form'
import { mapFields } from 'vuex-map-fields'

export default {
	beforeRouteLeave (to, from, next) {
		this.clearPage()

		next()
	},

	computed: {
		...mapFields([
			'signIn',
			'loading',
			'error',
			'isPasswordResetSuccess'
		])
	},

	methods: {
		/* Login */
		async login () {
			if (this.loading) return

			this.error = ''

			const { form, validated } = await this.validate()

			if (validated) {
				const formData = new FormData()
				formData.append('email', form.get('email'))
				formData.append('password', form.get('password'))

				await this.$store.dispatch('login', { form: formData, router: this.$router })
			}
		},

		async validate () {
			const form = new Form(this.signIn)
			const data = {
				form,
				validated: true
			}

			if (!form.isValidEmail('email')) {
				data.validated = false
				this.error = 'Please enter valid Email.'
			}

			if (form.isEmptyString('password')) {
				data.validated = false
				this.error = 'Please enter your Password.'
			}

			return data
		},

		/* Before Route Leave */
		clearPage () {
			this.signIn = {
				email: '',
				password: ''
			}

			this.error = ''

			this.isPasswordResetSuccess = false
		}
	}
}
</script>

<style lang="scss" scoped>
.sign-in {
    height: 100%;
    width: 100%;
    color: #fff;

    .logo {
        margin-bottom: 20px;
    }

    .error-card {
        background-color: $danger;
        padding: 10px;
        color: #fff;
        border-radius: 5px;
        margin-bottom: 20px;
        @include flex-row(flex-start, center);

        p {
            margin-left: 10px;
            font-style: italic;
        }
    }

    .success-card {
        background-color: $success;
        padding: 10px;
        color: #fff;
        border-radius: 5px;
        margin-bottom: 20px;
        @include flex-row(flex-start, center);

        p {
            margin-left: 10px;
            font-style: italic;
        }
    }

    header {
        margin-bottom: 20px;
    }

    form {
        label {
            color: #fff;
            margin-bottom: 20px;
            display: block;
            width: 100%;
            cursor: pointer;

            input {
                display: block;
                width: 100%;
                margin-top: 15px;
                padding: 10px 15px;
                font-weight: 400;

                &::placeholder {
                    font-weight: 400;
                    color: #95989a;
                }
            }
        }

        a {
            color: #fff;
            margin: 10px 0;
            display: inline-block;
            transition: 0.3s;

            &:hover {
                text-decoration: underline;
            }
        }

        button {
            border: 2px solid #fff;
            color: #fff;
            font-size: 18px;
            margin: 10px 0;
            background-color: transparent;
            width: 100%;
            transition: 0.3s;
            padding: 10px 0;

            &:hover {
                background-color: $primary;
                border-color: $primary;
            }
        }
    }

    header {
        h2, p {
            text-align: center;
            margin-bottom: 15px;
        }
    }
}
</style>
